// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".last-scan[data-v-41448f40]{grid-area:last-scan}", ""]);
// Exports
module.exports = exports;
